import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonInternalSignedOutWidget, EnvironmentService, ErrorService, InternalAuthService, SpinnerService, UrlService, UtilityService } from '@eforall/common';
import { DashboardErrorPart, DashboardSpinnerWidget } from '@eforall/dashboard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../environments';
import { AppDataService } from '../../services';


@Component({
	selector: 'bootstrap-page',
	imports: [
		DashboardErrorPart,
		DashboardSpinnerWidget,
		CommonInternalSignedOutWidget,
		NgbModule,
		RouterOutlet,
	],
	templateUrl: `bootstrap.page.html`,
	styleUrl: `bootstrap.page.scss`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BootstrapPage {

	public spinnerService = inject(SpinnerService);
	public errorService = inject(ErrorService);

	private env = inject(EnvironmentService);
	public auth = inject(InternalAuthService);
	private router = inject(Router);
	private util = inject(UtilityService);
	private urlService = inject(UrlService);
	public appData = inject(AppDataService);

	// private pwa = inject(PwaService);



	constructor() {

		this.env.setEnvironment(environment);

	}
}
